import { WORLDWIDE_COUNTRY_ID } from "app/services/countryServiceConst";
import { devicesTypes } from "app/UtilitiesAndConstants/Constants/DevicesTypes";
import { displayAdvertisingNavigation } from "single-spa/react-app/config/solutions25/adIntelligence/displayAdvertising/displayAdvertisingNavigator";
import { searchAdvertisingNavigation } from "single-spa/react-app/config/solutions25/adIntelligence/searchAdvertising/searchAdvertisingNavigator";

const LAST_28_DAYS = "28d";

type NavigateToAdsIntelCommonParams = {
    domain: string;
    country?: number;
};

export const navigateToDisplayAds = ({ domain, country = WORLDWIDE_COUNTRY_ID }: NavigateToAdsIntelCommonParams) => {
    const params = {
        country,
        duration: LAST_28_DAYS,
        ignoreFilterConsistency: true,
        key: domain,
        // Explicit webSource avoids webSourceNavChangeHandler redirecting with location:"replace",
        // which would erase the alerts page from history (breaks browser Back). See: filters-bar/utils.ts pagesWebsources.
        webSource: devicesTypes.TOTAL,
    };

    void displayAdvertisingNavigation.ads.go(params);
};

type NavigateToSearchAdsParams = NavigateToAdsIntelCommonParams & {
    selectedPageTab?: "Text" | "Product";
};

export const navigateToSearchAds = ({
    domain,
    country = WORLDWIDE_COUNTRY_ID,
    selectedPageTab = "Text",
}: NavigateToSearchAdsParams) => {
    const params = {
        country,
        duration: LAST_28_DAYS,
        ignoreFilterConsistency: true,
        key: domain,
        selectedPageTab,
        // Explicit webSource avoids webSourceNavChangeHandler redirecting with location:"replace",
        // which would erase the alerts page from history (breaks browser Back). See: filters-bar/utils.ts pagesWebsources.
        webSource: devicesTypes.TOTAL,
    };

    void searchAdvertisingNavigation.textAndShoppingAds.go(params);
};
